module.exports = __webpack_public_path__ + "static/media/video-hand-disabled.8d9f8958.svg";